import type { Command } from 'commander';
import type { DuoCommand, Example } from '../duo_command';
import { openOrListSessionLogFiles } from './session_log_search';

const examples: Example[] = [
  {
    title: 'Find the log file(s) for a session',
    exampleCommand: 'duo log session-id 4122303',
  },
];

export class LogSessionIdCommand implements DuoCommand {
  readonly name = 'session-id <sessionId>';

  readonly description = 'Find the log file(s) referencing a session or workflow ID.';

  readonly synopsis =
    'Opens the matching log file in `$EDITOR` when exactly one is found. Otherwise ' +
    'prints the path of every matching file — a session resumed across multiple ' +
    '`duo` invocations can span more than one log file, since each process writes ' +
    'its own.';

  readonly examples = examples;

  register(node: Command): void {
    node.action((sessionId: string) => {
      openOrListSessionLogFiles(sessionId);
    });
  }
}
